// Le pagine che non leggono dati di un tenant: un admin le usa anche senza
// tenant attivo. `/tenants` comprende il dettaglio.
const TENANTLESS_ROUTES = [/^\/tenants(\/.*)?$/];

export const isTenantlessPath = (pathname) =>
  TENANTLESS_ROUTES.some((route) => route.test(pathname ?? ''));
